import { useTranslation } from 'react-i18next';

import { NavItem } from 'src/components/Buttons/NavItem';
import { House } from 'lucide-react';
import {
    getPrimaryRole,
    isOrganizationAdministrator,
    UserRole,
} from 'src/domain/user';
import { useSignedInUser } from 'src/view/hooks/useSignedInUser';

export const LinkToHome = () => {
    const user = useSignedInUser();
    const role = getPrimaryRole(user);
    const { t } = useTranslation();

    if (
        !role ||
        (role === UserRole.creator && !isOrganizationAdministrator(user))
    ) {
        return null;
    }

    return <NavItem icon={House} screen={'/app/home'} label={t('nav.home')} />;
};
